import './common.scss';
import './App.css';
import { ToastContainer } from "react-toastify";
import Navbar from './routes/Navbar/Navbar';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Login from './routes/Login/Login';
import Dashboard from './routes/Dashboard/Dashboard';
import MyOrders from './routes/MyOrders/MyOrders';
import Profile from './routes/Profile/Profile';
import Privacy from './routes/Privacy';
import Terms from './routes/Terms';
import ResetPassword from "./routes/ResetPassword/ResetPassword";
import RFQDetails from './routes/RFQDetails/RFQDetails';
import OrderDetails from './routes/OrderDetails/OrderDetails';
import Maintanence from './component/Maintanence';
import { useEffect } from 'react';
import qs from 'query-string';
import PrivateRoute from './routes/PrivateRoute';
import { firebaseSignOnLoginSuccess } from './utils/firebase';
import jwt_decode from 'jwt-decode';
import OfferDetails from './routes/OfferDetails/OfferDetails';
import OfferEdit from './routes/OfferDetails/OfferEdit';



function App() {
  let loggedIn = localStorage.getItem('isLoggedIn');
  let token = localStorage.getItem('Token');
  const location = useLocation();

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("_id");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("email");
    localStorage.removeItem("pathAfterLogin");
    navigate('/', { state: { from: location.pathname } });
  };

  // useEffect(() => {
  //   token = localStorage.getItem('Token');
  //   const isLoggedIn = localStorage.getItem("isLoggedIn");
  //   if (!token) {
  //     if (!(location.pathname.includes('verifyEmail'))) {
  //       handleLogout();
  //       return;
  //     }
  //   } else {
  //     let decode = jwt_decode(token);
  //     if ((decode.exp * 1000) < Date.now()) {
  //       handleLogout();
  //     }
  //     if ((decode.exp * 1000) - Date.now() < 1800) {
  //       handleLogout();
  //     }
  //   }

  //   if (isLoggedIn != 'true' && !(location.pathname.includes('verifyEmail'))) {
  //     handleLogout();
  //   }
  //   firebaseSignOnLoginSuccess();
  //   const { search, } = window.location;
  //   const param = qs.parse(search);
  //   if (param.redirected_url && token) {
  //     window.href = param.redirected_url + search;
  //   };
  // }, [])
  


  const loadGTM = () => {
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `Enter GTM function script`;
    document.head.appendChild(gtmScript);
  };

  const loadHeap = () => {
    // Add Heap script
    const heapScript = document.createElement("script");
    heapScript.type = "text/javascript";
    heapScript.innerHTML = `
      window.heapReadyCb=window.heapReadyCb||[],window.heap=window.heap||[],heap.load=function(e,t){window.heap.envId=e,window.heap.clientConfig=t=t||{},window.heap.clientConfig.shouldFetchServerConfig=!1;var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="https://cdn.us.heap-api.com/config/"+e+"/heap_config.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(a,r);var n=["init","startTracking","stopTracking","track","resetIdentity","identify","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"],i=function(e){return function(){var t=Array.prototype.slice.call(arguments,0);window.heapReadyCb.push({name:e,fn:function(){heap[e]&&heap[e].apply(heap,t)}})}};for(var p=0;p<n.length;p++)heap[n[p]]=i(n[p])};
      heap.load("3118503417");
    `;
    document.head.appendChild(heapScript);
  };


  useEffect(() => {
    console.log(
      "Current Host:",
      window.location.host,
      window.location.host === "sc.8xparts.com"
        ? "Analytics Loaded"
        : "Analytics Not Loaded"
    );

    if (window.location.host === "sc.8xparts.com") {
      // loadGTM();
      // loadHeap();
    }
  }, []);


  return (
    <div className="App ">
      <ToastContainer />
      <Routes>
        {process.env.REACT_APP_IN_MAINTANANCE == 'true' ?
          <>
            <Route path='/*' element={<Maintanence />} />
          </>
          :
          <>
            <Route path='/' element={loggedIn && token ? <Navigate to='/dashboard' /> : <Login />} />
            <Route path='/login' element={loggedIn && token ? <Navigate to='/dashboard' /> : <Login />} />
            <Route path="/:id/verifyEmail/" element={<ResetPassword />}></Route>

            <Route path="/privacy-policy" element={<Privacy />}></Route>
            <Route path="/terms-of-service" element={<Terms />}></Route>
            <Route path='/' element={<Navbar />}>

              <Route path='/dashboard' element={<PrivateRoute />}>
                <Route path='/dashboard' element={<Dashboard />} />
              </Route>
              <Route path='/my-orders' element={<PrivateRoute />}>
                <Route path='/my-orders' element={<MyOrders />} />
              </Route>

              <Route path='/profile' element={<PrivateRoute />}>
                <Route path='/profile' element={<Profile />} />
              </Route>
              <Route path='/rfq-details/:id' element={<PrivateRoute />}>
                <Route path="/rfq-details/:id" element={<RFQDetails />} />
              </Route>
              <Route path='/offer-details/:id' element={<PrivateRoute />}>
                <Route path="/offer-details/:id" element={<OfferDetails />} />
              </Route>

              <Route path='/offer-details/:id' element={<PrivateRoute />}>
                <Route path="/offer-details/:id" element={<OfferDetails />} />
              </Route>

              <Route path='/offer-edit/:id' element={<PrivateRoute />}>
                <Route path="/offer-edit/:id" element={<OfferEdit />} />
              </Route>
              <Route path='/order-details/:id' element={<PrivateRoute />}>
                <Route path="/order-details/:id" element={<OrderDetails />} />
              </Route>
            </Route>
          </>
        }

      </Routes>
    </div>
  );
}

export default App;
